import React from 'react';
import { styled } from 'styled-components';
import { ClusteringLabGroup } from '../types';

interface BreadcrumbProps {
  path: (string | null)[];
  groups: ClusteringLabGroup[];
  onNavigate: (depth: number) => void;
}

const Nav = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 16px;
  font-size: 14px;
  color: #4a5568;
  border-bottom: 1px solid #e2e8f0;
  background: #f7fafc;
`;

const Segment = styled.span<{ $clickable: boolean }>`
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  font-weight: ${(p) => (p.$clickable ? 400 : 600)};
  color: ${(p) => (p.$clickable ? '#3182ce' : '#2d3748')};

  &:hover {
    text-decoration: ${(p) => (p.$clickable ? 'underline' : 'none')};
  }
`;

const Separator = styled.span`
  color: #cbd5e0;
`;

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path, groups, onNavigate }) => {
  const groupMap = new Map(groups.map((g) => [g.group_id, g]));

  const segments = path.map((groupId, i) => {
    const label = groupId === null ? 'All Photos' : groupMap.get(groupId)?.label || `Group ${groupId}`;
    const isLast = i === path.length - 1;

    return (
      <React.Fragment key={i}>
        {i > 0 && <Separator>›</Separator>}
        <Segment $clickable={!isLast} onClick={() => !isLast && onNavigate(i)}>
          {label}
        </Segment>
      </React.Fragment>
    );
  });

  return <Nav>{segments}</Nav>;
};

export default Breadcrumb;
